module.exports = __webpack_public_path__ + "static/media/Ejemplo_Tarjeta.4ed805de.png";